import React from "react";

export default function RfpViewSwitch({
  value,
  onChange,
  scopeAnalysisAvailable,
}) {
  const tabBase =
    "rounded-lg border px-3 py-2 text-left transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-500";

  const selectedCls =
    "border-slate-800 bg-slate-800 text-white shadow-sm dark:border-slate-200 dark:bg-slate-200 dark:text-slate-900";
  const idleCls =
    "border-slate-200 bg-white text-slate-800 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900/80 dark:text-slate-100 dark:hover:bg-slate-800";

  return (
    <div
      data-testid="rfp-view-switch"
      className="grid w-full grid-cols-1 gap-2 sm:grid-cols-2"
      role="tablist"
      aria-label="Job view"
    >
      <button
        type="button"
        role="tab"
        data-testid="rfp-view-switch-analysis-scope"
        data-view-switch-tab="analysis_scope"
        aria-label="Analysis (RFP Discovery Scope)"
        aria-selected={value === "analysis_scope"}
        className={`${tabBase} ${value === "analysis_scope" ? selectedCls : idleCls}`}
        onClick={() => onChange("analysis_scope")}
      >
        <span className="block text-sm font-semibold">Analysis (RFP Discovery Scope)</span>
        <span
          className={`mt-0.5 block text-xs leading-snug ${
            value === "analysis_scope"
              ? "text-slate-300 dark:text-slate-600"
              : "text-slate-500 dark:text-slate-400"
          }`}
        >
          Scope review and technology analysis
          {!scopeAnalysisAvailable ? " · Not generated yet." : ""}
        </span>
      </button>
      <button
        type="button"
        role="tab"
        data-testid="rfp-view-switch-review"
        data-view-switch-tab="review"
        aria-label="Compliance Review"
        aria-selected={value === "review"}
        className={`${tabBase} ${value === "review" ? selectedCls : idleCls}`}
        onClick={() => onChange("review")}
      >
        <span className="block text-sm font-semibold">Compliance Review</span>
        <span
          className={`mt-0.5 block text-xs leading-snug ${
            value === "review"
              ? "text-slate-300 dark:text-slate-600"
              : "text-slate-500 dark:text-slate-400"
          }`}
        >
          Requirements grid and compliance results
        </span>
      </button>
    </div>
  );
}
